const MAX_STRING = 500;
const MAX_DEPTH = 4;
const MAX_KEYS = 20;
const MAX_ITEMS = 20;

function truncate(s: string, max = MAX_STRING): string {
  return s.length > max ? s.slice(0, max) + "… [tronqué]" : s;
}

function serializeValue(value: unknown, depth: number, seen: WeakSet<object>): unknown {
  if (value === null || value === undefined) return value;
  const t = typeof value;
  if (t === "string") return truncate(value as string);
  if (t === "number" || t === "boolean") return value;
  if (t === "bigint" || t === "symbol" || t === "function") return String(value);
  if (value instanceof Error) {
    return { name: value.name, message: truncate(value.message), stack: value.stack ? truncate(value.stack, 1500) : undefined };
  }
  if (value instanceof Date) return value.toISOString();
  if (typeof Node !== "undefined" && value instanceof Node) {
    return `<${(value as Element).tagName?.toLowerCase() ?? value.nodeName}>`;
  }
  if (depth >= MAX_DEPTH) return "[profondeur max]";
  if (seen.has(value as object)) return "[circulaire]";
  seen.add(value as object);
  if (Array.isArray(value)) {
    const items = value.slice(0, MAX_ITEMS).map((v) => serializeValue(v, depth + 1, seen));
    if (value.length > MAX_ITEMS) items.push(`… ${value.length - MAX_ITEMS} de plus`);
    return items;
  }
  const out: Record<string, unknown> = {};
  let count = 0;
  for (const key of Object.keys(value as object)) {
    if (count >= MAX_KEYS) {
      out["…"] = "clés supplémentaires omises";
      break;
    }
    try {
      out[key] = serializeValue((value as Record<string, unknown>)[key], depth + 1, seen);
    } catch {
      out[key] = "[non sérialisable]";
    }
    count++;
  }
  return out;
}

/** Sérialise une liste d'arguments console en une chaîne lisible et bornée. */
export function serializeArgs(args: unknown[]): string {
  const parts = args.map((arg) => {
    if (typeof arg === "string") return truncate(arg, 1000);
    try {
      const v = serializeValue(arg, 0, new WeakSet());
      return typeof v === "string" ? v : JSON.stringify(v);
    } catch {
      return "[non sérialisable]";
    }
  });
  return truncate(parts.join(" "), 2000);
}
